import { render, staticRenderFns } from "./backlist-info.vue?vue&type=template&id=3aa7baaf&scoped=true"
import script from "./backlist-info.vue?vue&type=script&lang=js"
export * from "./backlist-info.vue?vue&type=script&lang=js"
import style0 from "./backlist-info.vue?vue&type=style&index=0&id=3aa7baaf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa7baaf",
  null
  
)

export default component.exports